document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-press').forEach(function (section) {
    var mode = section.getAttribute('data-press-mode');
    var track = section.querySelector('[data-press-track]');
    if (!track) return;

    if (mode === 'arrows') {
      var prevBtn = section.querySelector('[data-press-prev]');
      var nextBtn = section.querySelector('[data-press-next]');
      if (!prevBtn || !nextBtn) return;

      function scrollAmount() {
        var firstCard = track.querySelector('.custom-press__card');
        if (!firstCard) return 340;
        var style = window.getComputedStyle(track);
        var gap = parseInt(style.columnGap || style.gap || 16, 10);
        return firstCard.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);
      updateButtons();
      return;
    }

    if (mode === 'infinite') {
      var viewport = section.querySelector('.custom-press__viewport');
      var firstGroup = track.querySelector('[data-press-group]');
      if (!viewport || !firstGroup) return;

      var templateHTML = firstGroup.outerHTML;

      function addGroup(hidden) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = templateHTML;
        var groupEl = wrapper.firstElementChild;
        if (hidden) {
          groupEl.setAttribute('aria-hidden', 'true');
          groupEl.querySelectorAll('a').forEach(function (a) {
            a.setAttribute('tabindex', '-1');
          });
        }
        track.appendChild(groupEl);
      }

      function rebuild() {
        track.innerHTML = '';
        addGroup(false);
        addGroup(true);

        var containerWidth = viewport.clientWidth;
        var safety = 0;
        while (track.scrollWidth < containerWidth * 2 && safety < 30) {
          addGroup(true);
          safety++;
        }

        var groupCount = track.querySelectorAll('.custom-press__group').length;
        if (groupCount % 2 !== 0) {
          addGroup(true);
        }
      }

      var images = track.querySelectorAll('img');
      var pending = images.length;

      function onImageDone() {
        pending--;
        if (pending <= 0) rebuild();
      }

      if (pending === 0) {
        rebuild();
      } else {
        images.forEach(function (img) {
          if (img.complete) {
            onImageDone();
          } else {
            img.addEventListener('load', onImageDone, { once: true });
            img.addEventListener('error', onImageDone, { once: true });
          }
        });
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(rebuild, 200);
      });
    }
  });
});